<div>
  <form [formGroup]="additionalDataFormGroup">
    @if (areAdditionalDataVisible$ | async) {
      <div class="content-card">
        <h2>{{ 'WF-AdditionalData' | translate }}</h2>
        <div class="row">
          <div class="col-12">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'WF-NationalHealthFund' | translate }}</mat-label>
              <mat-select formControlName="nationalHealthFund" required>
                @for (nationalHealthFund of listOfNationalHealthFunds$ | async; track nationalHealthFund) {
                  <mat-option
                    [value]="nationalHealthFund.Id">
                  {{ nationalHealthFund.Name }}</mat-option>
                }
              </mat-select>
              @if (nationalHealthFund.invalid && nationalHealthFund.touched) {
                <mat-error>
                  {{ 'InvalidField' | translate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <alert alertType="info" [message]="'TaxOfficeShouldBeSameAsAddress' | translate"></alert>
            <mat-form-field appearance="outline">
              <mat-label>{{ 'WF-TaxOffice' | translate }}</mat-label>
              <input type="text" formControlName="taxOffice" placeholder="{{ 'WF-TaxOffice' | translate }}"
                [matAutocomplete]="autocompleteTaxOffice" matInput required />
                <mat-autocomplete #autocompleteTaxOffice="matAutocomplete" [displayWith]="displayValue">
                  @for (taxOffice of listOfTaxOffices$ | async; track taxOffice) {
                    <mat-option [value]="taxOffice">
                      {{ taxOffice.Name }}
                    </mat-option>
                  }
                </mat-autocomplete>
                @if (taxOffice.invalid && taxOffice.touched) {
                  <mat-error>
                    {{ 'InvalidField' | translate }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
          @if (hasDeclarationAddressConfigEnabled) {
            <mat-divider></mat-divider>
            <div class="row">
              <div class="col-12 col-lg-12">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'WF-DeclarationAddressType' | translate }}</mat-label>
                  <mat-select id="declarationAddressType" formControlName="declarationAddressType">
                    @for (addressType of listOfAddressTypes$ | async; track addressType) {
                      <mat-option [value]="addressType.Id"> {{
                      addressType.Name }}</mat-option>
                    }
                  </mat-select>
                  @if (declarationAddressType.invalid && declarationAddressType.touched) {
                    <mat-error>
                      {{ 'InvalidField' | translate }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-lg-12">
                <div class="radio-group-form-field">
                  <mat-label>{{ 'WF-DocumentDeliveryMethod' | translate }}</mat-label>
                  <mat-radio-group formControlName="documentDeliveryMethod" aria-label="Select an option">
                    @for (deliveryMethod of listOfDocumentDeliveryMethods$ | async; track deliveryMethod) {
                      <mat-radio-button
                        [value]="deliveryMethod.Id">{{
                        deliveryMethod.Name
                      }}</mat-radio-button>
                    }
                  </mat-radio-group>
                  @if (documentDeliveryMethod.invalid && documentDeliveryMethod.touched) {
                    <mat-divider></mat-divider>
                  }
                  @if (documentDeliveryMethod.invalid && documentDeliveryMethod.touched) {
                    <mat-error>
                      {{ 'InvalidField' | translate }}
                    </mat-error>
                  }
                </div>
              </div>
            </div>
            @if (documentDeliveryMethod.value === documentDeclarationMethods.PaperForm) {
              <div class="row">
                <div class="col-12 col-lg-12">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'WF-AddressToSendDeclaration' | translate }}</mat-label>
                    <mat-select id="addressToSendDeclarationAddressType"
                      formControlName="addressToSendDeclarationAddressType">
                      @for (addressType of listOfAddressTypes$ | async; track addressType) {
                        <mat-option [value]="addressType.Id"> {{
                        addressType.Name }}</mat-option>
                      }
                    </mat-select>
                    @if (addressToSendDeclarationAddressType.invalid && addressToSendDeclarationAddressType.touched) {
                      <mat-error
                        >
                        {{ 'InvalidField' | translate }}
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
              </div>
            }
            @if (documentDeliveryMethod.value === documentDeclarationMethods.ElectronicForm) {
              <div class="row">
                <div class="col-12 col-lg-12">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'WF-EmailToSendDeclaration' | translate }}</mat-label>
                    <input matInput formControlName="emailToSendDeclaration" type="text" autocomplete="emailToSendDeclaration"
                      [placeholder]="'WF-EmailToSendDeclaration' | translate" />
                      @if (emailToSendDeclaration.invalid && emailToSendDeclaration.touched) {
                        <mat-error>
                          {{ 'InvalidField' | translate }}
                        </mat-error>
                      }
                    </mat-form-field>
                  </div>
                </div>
              }
              <mat-divider></mat-divider>
            }
            <div class="row">
              <div class="col-12">
                <div [matTooltip]="!canEditBankAccountData ? ('BankAccountNumberTooltip' | translate) : ''">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'WF-BankAccountNumber' | translate }}</mat-label>
                    <input matInput type="text" appBankAccountMask placeholder="{{ 'WF-BankAccountNumber' | translate }}"
                      formControlName="bankAccountNumber" [required]="isExternalWorker()" />
                      @if (bankAccountNumber.invalid && bankAccountNumber.touched) {
                        <mat-error>
                          {{ 'InvalidField' | translate }}
                        </mat-error>
                      }
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-12">
                  <mat-checkbox formControlName="isBankAccountDoesntBelongToWorker">
                    {{ 'WF-BankAccountDoesntBelongToMe' | translate }}
                  </mat-checkbox>
                </div>
                @if (isBankAccountDoesntBelongToWorker.value) {
                  <div class="col-12">
                    <div class="row account-owner-data">
                      <div class="col-12 col-lg-6">
                        <mat-form-field appearance="outline">
                          <mat-label>{{ 'WF-GiveFirstNameIfBankAccountDoesntBelongToYou' | translate }}</mat-label>
                          <input matInput placeholder="{{ 'WF-EnterBankAccountOwnerFirstName' | translate }}" autocomplete="name"
                            formControlName="bankAccountOwnerFirstName" maxlength="50" />
                            @if (bankAccountOwnerFirstName.invalid && bankAccountOwnerFirstName.touched) {
                              <mat-error>
                                {{ 'InvalidField' | translate }}
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                        <div class="col-12 col-lg-6">
                          <mat-form-field appearance="outline">
                            <mat-label>{{ 'WF-GiveLastNameIfBankAccountDoesntBelongToYou' | translate }}</mat-label>
                            <input matInput placeholder="{{ 'WF-EnterBankAccountOwnerLastName' | translate }}" autocomplete="name"
                              formControlName="bankAccountOwnerLastName" maxlength="50" />
                              @if (bankAccountOwnerLastName.invalid && bankAccountOwnerLastName.touched) {
                                <mat-error>
                                  {{ 'InvalidField' | translate }}
                                </mat-error>
                              }
                            </mat-form-field>
                          </div>
                        </div>
                        @if (
                          additionalDataFormGroup.invalid && additionalDataFormGroup.touched && !!additionalDataFormGroup.errors?.bankAccountOwnerFullNameInvalid
                          ) {
                          <alert message="BankAccountOwnerFullNameInvalid" alertType="error"></alert>
                        }
                      </div>
                    }
                  </div>
                </div>
              }

              @if (hasAccessToHrNumbers) {
                <div class="content-card">
                  <h2 class="content-card__header">{{ 'WF-HrNumberSection' | translate }}</h2>
                  <div formArrayName="hrNumbers">
                    @for (group of hrNumbers.controls; track trackByIndex(i, group); let i = $index) {
                      <div [formGroupName]="i"
                        class="hr-number-item">
                        <div class="row">
                          <div class="col-12">
                            <mat-form-field appearance="outline">
                              <mat-label>{{ 'WF-HrNumber' | translate }}</mat-label>
                              <input matInput type="text" formControlName="hrNumber" maxlength="20" />
                              @if (hrCtrl(i)?.invalid && hrCtrl(i)?.touched) {
                                <mat-error>
                                  {{ 'InvalidField' | translate }}
                                </mat-error>
                              }
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }

              <div class="content-card">
                <h2 class="content-card__header">{{ 'WF-EmergencyContact' | translate }}</h2>

                <div class="row">
                  <div class="col-12 col-lg-4">
                    <mat-form-field appearance="outline">
                      <mat-label>{{ 'WF-EmergencyContactFirstName' | translate }}</mat-label>
                      <input matInput placeholder="{{ 'WF-EmergencyContactFirstName' | translate }}" autocomplete="given-name"
                        formControlName="emergencyContactFirstName" maxlength="50" />
                        @if (emergencyContactFirstName.invalid && emergencyContactFirstName.touched) {
                          <mat-error>
                            {{ 'InvalidField' | translate }}
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>

                    <div class="col-12 col-lg-4">
                      <mat-form-field appearance="outline">
                        <mat-label>{{ 'WF-EmergencyContactLastName' | translate }}</mat-label>
                        <input matInput placeholder="{{ 'WF-EmergencyContactLastName' | translate }}" autocomplete="family-name"
                          formControlName="emergencyContactLastName" maxlength="50" />
                          @if (emergencyContactLastName.invalid && emergencyContactLastName.touched) {
                            <mat-error>
                              {{ 'InvalidField' | translate }}
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>

                      <div class="col-12 col-lg-2">
                        <mat-form-field appearance="outline">
                          <mat-label>{{ 'PhoneCode' | translate }}</mat-label>
                          <mat-select formControlName="emergencyContactPhoneCodeId">
                            @for (phoneCode of listOfPhoneCodes$ | async; track phoneCode) {
                              <mat-option #matOption [value]="phoneCode.Id">{{
                              phoneCode.Prefix }}</mat-option>
                            }
                          </mat-select>
                          @if (emergencyContactPhoneCodeId.invalid && emergencyContactPhoneCodeId.touched) {
                            <mat-error>
                              {{ 'InvalidField' | translate }}
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>

                      <div class="col-12 col-lg-2">
                        <mat-form-field appearance="outline">
                          <mat-label>{{ 'WF-EmergencyContactPhone' | translate }}</mat-label>
                          <input matInput #phoneNumberInput placeholder="{{ 'WF-EmergencyContactPhone' | translate }}"
                            autocomplete="phoneNumber" formControlName="emergencyContactPhone" [maxLength]="12" />
                            @if (emergencyContactPhone.invalid && emergencyContactPhone.touched) {
                              <mat-error>
                                {{ 'InvalidField' | translate }}
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                      </div>

                      @if (!emergencyContactPhone.value || emergencyContactPhone.invalid) {
                        <alert message="EmergencyContactInfo"
                        alertType="info"></alert>
                      }

                      <div class="row">
                        <div class="col-12">
                          <mat-form-field appearance="outline">
                            <mat-label>{{ 'WF-EmergencyContactAddress' | translate }}</mat-label>
                            <input matInput placeholder="{{ 'WF-EmergencyContactAddress' | translate }}"
                              formControlName="emergencyContactAddress" [maxLength]="100" />
                              @if (emergencyContactAddress.invalid && emergencyContactAddress.touched) {
                                <mat-error>
                                  {{ 'InvalidField' | translate }}
                                </mat-error>
                              }
                            </mat-form-field>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12">
                            <mat-checkbox [disabled]="true" [checked]="true">
                              {{ 'WF-ContactPersonConsent' | translate }}
                            </mat-checkbox>
                          </div>
                        </div>

                        <div class="header-wrapper"></div>

                        <div fxLayout="row" fxLayoutAlign="space-between center">
                          <button mat-raised-button color="accent" matStepperPrevious>
                            <mat-icon>arrow_back</mat-icon>
                            {{ 'Back' | translate }}
                          </button>
                          <button mat-raised-button color="primary" (click)="submitAdditionalData(false)">
                            {{ 'Next' | translate }}
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>